import React, { useEffect, useState } from 'react'
import { arrayOf, getLabel, instanceOf } from '../../../../utils/StoreUtils'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import DtoJob from '../../../../import/dto/DtoJob'
import DtoPiezometryStationMeasure from '../../../../station/dto/piezometer/DtoPiezometryStationMeasure'
import { getDate, getFullDate } from '../../../../utils/DateUtil'
import { hasValue, round } from '../../../../utils/NumberUtil'
import { getQualificationColor, getStatusIcon } from '../../../../utils/AnalyseUtils'
import { getColorCircleElement, getRGBColor } from '../../../../utils/ColorUtil'
import { getSandreLabel } from '../../../../utils/StringUtil'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import DtoStatus from '../../../../quality/dto/DtoStatus'
import DtoQualification from '../../../../quality/dto/DtoQualification'
import DtoSandreCode from '../../../../referencial/dto/DtoSandreCode'
import DtoContributor from '../../../../station/dto/DtoContributor'
import { getMeasureValue } from '../../../../utils/PiezometryUtils'
import DtoMeasureStats from '../../../../station/dto/piezometer/DtoMeasureStats'
import JobAction from '../../../../import/actions/JobAction'
import { Grid2 } from '@mui/material'
import { push } from '@lagunovsky/redux-react-router'


const SelectedMeasurePanel = ({
    measure = {},
    message= '',
    displayCote= undefined,
    lastLandmark= undefined,
    groundRefAlti= undefined,
}) =>{
    const {
        status,
        qualifications,
        sandreCodes,
        contributors,
        piezometerStatistics,
    } = useSelector(store => ({
        jobExecutions: store.JobReducer.jobExecutions,
        jobs: store.JobReducer.jobs,
        status: store.QualityReducer.status,
        qualifications: store.QualityReducer.qualifications,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        contributors: store.ContributorReducer.contributors,
        piezometerStatistics: store.PiezometerStationReducer.piezometerStatistics,
    }), shallowEqual)

    const [job, setJob] = useState({})

    const dispatch = useDispatch()


    useEffect(() => {
        if (measure?.jobExecutionId) {
            dispatch(JobAction.getJobByJobExecutionId(measure.jobExecutionId)).then(res => {
                setJob(res)
            })
        }
    }, [measure])

    if (measure) {
        const unit = piezometerStatistics.find(t => t.typeId === measure.unit)?.unit ?? ''
        const calculated = getMeasureValue(measure, displayCote, lastLandmark, groundRefAlti)
        const calculatedInitial = getMeasureValue(measure, displayCote, lastLandmark, groundRefAlti, true)
        return (
            <Grid2 container sx={{ paddingLeft: '10px' }}>
                <Grid2 size={12}><h6 className='bold'>{ message }</h6></Grid2>
                <Grid2 size={12}>{ `${getFullDate(measure.date)} : ${round(calculated)} ${unit}${calculated !== calculatedInitial ? ` (${i18n.corrected})` : ''}` }</Grid2>
                { measure.updateDate && measure.updateLogin && <Grid2 size={12}>{ `${i18n.updatedOn + getDate(measure.updateDate)} ${i18n.by} ${measure.updateLogin}` }</Grid2> }
                <Grid2 size={12} container>
                    { hasValue(measure.status) && <Grid2 size={6}>{ getStatusIcon(measure.status, status) }{ getLabel(status, measure.status) }</Grid2> }
                    { hasValue(measure.qualification) && <Grid2 size={6}>{ getColorCircleElement(getRGBColor(getQualificationColor(measure.qualification)), true) }{ getLabel(qualifications, measure.qualification) }</Grid2> }
                </Grid2>
                <Grid2 size={12} container>
                    { hasValue(measure.nature) && <Grid2 size={6}>{ (`${i18n.nature} : ${getSandreLabel(sandreCodes, SANDRE.PIEZOMETER_MEASURE_NATURE, measure.nature)}`) }</Grid2> }
                    { hasValue(measure.producer) && <Grid2 size={6}>{ (`${i18n.producer} : ${getLabel(contributors, measure.producer, 'mnemonique')}`) }</Grid2> }
                </Grid2>
                <Grid2 size={12} container>
                    { hasValue(measure.landmark) && <Grid2 size={6}>{ `${i18n.landmark} : ${measure.landmark}${unit}` }</Grid2> }
                    { hasValue(measure.refAlti) && <Grid2 size={6}>{ `${i18n.refAlti} : ${measure.refAlti}${unit}` }</Grid2> }
                </Grid2>
                <Grid2 size={12} container>
                    { hasValue(measure.measureMode) && <Grid2 size={6}>{ (`${i18n.obtainningMode} : ${getSandreLabel(sandreCodes, SANDRE.OBTAINING_MODE, measure.measureMode)}`) }</Grid2> }
                    { hasValue(measure.initialPoint) && <Grid2 size={6}>{ `${i18n.initialPoint} : ${measure.initialPoint === 1 ? i18n.yes : i18n.no}` }</Grid2> }
                </Grid2>
                <Grid2 size={12} container>
                    { hasValue(measure.manager) && <Grid2 size={6}>{ (`${i18n.administrator} : ${getLabel(contributors, measure.manager, 'mnemonique')}`) }</Grid2> }
                    { hasValue(measure.validator) && <Grid2 size={6}>{ (`${i18n.validator} : ${getLabel(contributors, measure.validator, 'mnemonique')}`) }</Grid2> }
                </Grid2>
                { (calculated !== calculatedInitial) && <Grid2 size={12}>{ `${i18n.beforeCorrectionValue} : ${round(calculatedInitial)}${unit}` }</Grid2> }
                { measure.importDate && <Grid2 size={12}>{ `${i18n.createdOn} ${getFullDate(measure.importDate)}` }</Grid2> }
                { job && <Grid2 size={12} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => dispatch(push(`/import/${job.id}?jobExecutionId=${measure.jobExecutionId}`))}>{ `${i18n.importName} : ${job.name || ''} ${job.login || ''} [${measure.jobExecutionId}]`}</Grid2> }
                { !job && measure.jobExecutionId && <Grid2 size={12}>{ i18n.jobDoesNotExistAnymore }</Grid2> }
            </Grid2>
        )
    }
    return null
}

SelectedMeasurePanel.propTypes = {
    measure: instanceOf(DtoPiezometryStationMeasure),
    jobs: arrayOf(DtoJob),
    message: PropTypes.string,
    status: arrayOf(DtoStatus),
    qualifications: arrayOf(DtoQualification),
    sandreCodes: arrayOf(DtoSandreCode),
    contributors: arrayOf(DtoContributor),
    piezoMode: PropTypes.bool,
    displayCote: PropTypes.number,
    lastLandmark: PropTypes.number,
    groundRefAlti: PropTypes.number,
    piezometerStatistics: arrayOf(DtoMeasureStats),
}

export default SelectedMeasurePanel